// Auto generated file, do not manually modify!
// com.hotpads.satellite.web.api.web.v1.conversation.SatelliteWebConversationHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  SatelliteWebConversationHandler_deleteAttachments,
  SatelliteWebConversationHandler_getDocumentUploadToken,
  SatelliteWebConversationHandler_getDocumentUploadToken_Path,
  SatelliteWebConversationHandler_getZdocIdsForMessageTokens,
  SatelliteWebConversationHandler_getZdocIdsForMessageTokens_Path,
} from '@zg-rentals/ts-satellite-client';

import type {
  SatelliteWebDeleteAttachmentsRequestDto,
  SatelliteWebGetDocumentUploadTokenResponseDto,
  SatelliteWebZdocIdsForMessageTokensRequestDto,
  SatelliteWebZdocIdsForMessageTokensResponseDto,
} from '@zg-rentals/ts-satellite-client';

export interface SatelliteWebConversationHandler_deleteAttachments_Args {
  postData: SatelliteWebDeleteAttachmentsRequestDto;
}

export type SatelliteWebConversationHandler_deleteAttachments_Options = UseMutationOptions<
  void,
  unknown,
  SatelliteWebConversationHandler_deleteAttachments_Args
>;

export const useSatelliteWebConversationHandler_deleteAttachments = ({
  httpClient,
  ...options
}: Omit<SatelliteWebConversationHandler_deleteAttachments_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: SatelliteWebConversationHandler_deleteAttachments_Args) =>
      SatelliteWebConversationHandler_deleteAttachments(args.postData, httpClient),
  });
};

export type SatelliteWebConversationHandler_getDocumentUploadToken_Options = UseQueryOptions<
  SatelliteWebGetDocumentUploadTokenResponseDto,
  unknown,
  SatelliteWebGetDocumentUploadTokenResponseDto,
  readonly [string]
>;

const SatelliteWebConversationHandler_getDocumentUploadToken_GetKey = () =>
  [SatelliteWebConversationHandler_getDocumentUploadToken_Path] as const;

export const SatelliteWebConversationHandler_getDocumentUploadToken_queryOptions = ({
  httpClient,
}: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: SatelliteWebConversationHandler_getDocumentUploadToken_GetKey(),
    queryFn: () => SatelliteWebConversationHandler_getDocumentUploadToken(httpClient),
  }) as const satisfies QueryOptions;

export const useSatelliteWebConversationHandler_getDocumentUploadToken = ({
  httpClient,
  ...options
}: Omit<SatelliteWebConversationHandler_getDocumentUploadToken_Options, 'queryFn' | 'queryKey'> & {
  httpClient?: Client;
} = {}) => {
  return useQuery({
    ...SatelliteWebConversationHandler_getDocumentUploadToken_queryOptions({ httpClient }),
    ...options,
  });
};
useSatelliteWebConversationHandler_getDocumentUploadToken.getKey =
  SatelliteWebConversationHandler_getDocumentUploadToken_GetKey;

export type SatelliteWebConversationHandler_getZdocIdsForMessageTokens_Options = UseQueryOptions<
  SatelliteWebZdocIdsForMessageTokensResponseDto,
  unknown,
  SatelliteWebZdocIdsForMessageTokensResponseDto,
  readonly [string, SatelliteWebZdocIdsForMessageTokensRequestDto]
>;

const SatelliteWebConversationHandler_getZdocIdsForMessageTokens_GetKey = (
  postData: SatelliteWebZdocIdsForMessageTokensRequestDto,
) => [SatelliteWebConversationHandler_getZdocIdsForMessageTokens_Path, postData] as const;

export const SatelliteWebConversationHandler_getZdocIdsForMessageTokens_queryOptions = (
  postData: SatelliteWebZdocIdsForMessageTokensRequestDto,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: SatelliteWebConversationHandler_getZdocIdsForMessageTokens_GetKey(postData),
    queryFn: () => SatelliteWebConversationHandler_getZdocIdsForMessageTokens(postData, httpClient),
  }) as const satisfies QueryOptions;

export const useSatelliteWebConversationHandler_getZdocIdsForMessageTokens = (
  postData: SatelliteWebZdocIdsForMessageTokensRequestDto,
  {
    httpClient,
    ...options
  }: Omit<SatelliteWebConversationHandler_getZdocIdsForMessageTokens_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...SatelliteWebConversationHandler_getZdocIdsForMessageTokens_queryOptions(postData, { httpClient }),
    ...options,
  });
};
useSatelliteWebConversationHandler_getZdocIdsForMessageTokens.getKey =
  SatelliteWebConversationHandler_getZdocIdsForMessageTokens_GetKey;
